app.controller(
    'AdminCityCreationController', ['$scope', '$rootScope', '$http', '$state', '$stateParams', '$timeout', 'toastr', '$document', 'Configuration', 'UserService', 'AdminService', '$sce', '$translate', AdminCityCreationController]
);

function AdminCityCreationController($scope, $rootScope, $http, $state, $stateParams, $timeout, toastr, $document, Configuration, UserService, AdminService, $sce, $translate) {
    var vm = this;
    $scope.searchText = "search";
    $scope.ZoneInfos = {
        CurrentZoneNameText: '',
        //DefaultZoneType: 'Classic',
        //ZoneType: [{ name: 'Classic' }, { name: 'Resort' }],
        AvailableLangList: [{ name: 'English' }, { name: 'French' }, { name: 'Chinois' }],
        AssociatedCityList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
    }

    $translate.use($rootScope.LangForInterface);

    initController();

    function initController() {
        GetAdminZoneInfoForCreation($rootScope.LangForWork);
    }

    function GetAdminZoneInfoForCreation(lang) {
        AdminService.GetAdminZoneInfoForCreation(lang)
            .then(function (zone) {
                $scope.ZoneInfos = zone.data;
                $scope.updateFieldTags();
            });
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };

    vm.CreateZone = function (zoneInfos) {        
        console.log(zoneInfos);
        AdminService.CreateZone(zoneInfos)
        .then(
                function success(data) {
                    $rootScope.RedirectFromZoneCreation = true;
                    $state.go('app.admin-liste-ville', { lang: $rootScope.LangForWork });
                },
                function error(data) {
                    alert(data);
                });
    }

    vm.GetCityListByKeyword = function () {
        AdminService.GetCityListByKeyword(0, $rootScope.LangForWork, $scope.searchText)
            .then(function (data) {
                $scope.ZoneInfos.AssociatedCityList = data.data;
            });
    }
}